import { createSelector } from "reselect";

import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";


const storeVsComparatorRankedLastTwelveMonthsGrowth = (state) => {
    return state.customer.insights.portfolio.sales.rankedGrowth.storeVsComparatorRankedLastTwelveMonthsGrowth;
};

const rollingGrowthClassification = createSelector(
    storeVsComparatorRankedLastTwelveMonthsGrowth,
    state => selectStore(state),
    state => selectComparator(state),
    (storeVsComparatorRankedLastTwelveMonthsGrowth, selectedStore, selectedComparator) => {
        const rag = {
            loading: false,
            error: false,
            id: "rolling-growth-classification",
            label: "Rolling growth classification",
            status: "info",
            value: ""
        };
        if (storeVsComparatorRankedLastTwelveMonthsGrowth.loading) {
            rag.loading = true;
            rag.error = false;
            return rag;
        }
        if (storeVsComparatorRankedLastTwelveMonthsGrowth.error) {
            rag.loading = false;
            rag.error = true;
            return rag;
        }

        const rank = storeVsComparatorRankedLastTwelveMonthsGrowth.rank;
        const denominator = storeVsComparatorRankedLastTwelveMonthsGrowth.denominator;
        const topThirdPercentile = 1 / 3;
        const bottomThirdPercentile = 2 / 3;
        const selectedPercentile = rank / denominator;

        //Logic copied from similar profit rag
        if (selectedPercentile < topThirdPercentile) {
            rag.status = "success";
            rag.value = `${selectedStore.name} is a top performer for 12 month rolling growth relative to ${selectedComparator.name}`;
        } else if (selectedPercentile > bottomThirdPercentile) {
            rag.status = "error";
            rag.value = `${selectedStore.name} is underperforming for 12 month rolling growth relative to ${selectedComparator.name}`;
        } else {
            rag.status = "warning";
            rag.value = `${selectedStore.name} is average for 12 month rolling growth relative to ${selectedComparator.name}`;
        }

        return rag;
    }
);

const selectors = {
    storeVsComparatorRankedLastTwelveMonthsGrowth,
    rollingGrowthClassification
};

export default selectors;
